export const ESA_AGGREGATOR_PAGE_FEATURE_FLAG = "esa-aggregator-page";
export const ESA_AGGREGATOR_VENDOR_DIRECTORY_FEATURE_FLAG =
  "esa-aggregator-vendor-directory";
export const EDUCATOR_ESA_HUB_FEATURE_FLAG = "educator-esa-hub";
export const FLEXIBLE_PAYMENT_METHOD_SELECTION_FEATURE_FLAG =
  "flexible-payment-method-selection";
export const BACK_TO_SCHOOL_HOMEPAGE_2026_FEATURE_FLAG =
  "back-to-school-homepage-2026";
export const CALIFORNIA_MANDATED_REPORTER_TRAINING_CREDENTIAL_FEATURE_FLAG =
  "ca-mandated-reporter-training-credential";
export const MEMBERSHIP_20_OFF_FIRST_MONTH_FEATURE_FLAG =
  "membership-20-off-first-month";
export const HYBRID_CLASSROOM_V2_FEATURE_FLAG = "hybrid-classroom-v2";
export const TEACHER_UNIFIED_MESSAGING_INBOX_FEATURE_FLAG =
  "teacher-unified-messaging-inbox";
